import { css } from "styled-components";

import { device } from "emoreg/const";

export const forTabletUp = (...args) => css`
  @media (min-width: ${device.mobile / 16}em) {
    ${css(...args)};
  }
`;
